import { Grid, InfiniteScroll } from '@syncfusion/ej2-angular-grids';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LeadsGridComponent } from './leads-grid/leads-grid.component';
import { SharedModule } from '../../shared/shared.module';
import { LeadsRoutingModule } from './leads.routing.module';
import { LeadsPopupComponent } from './leads-popup/leads-popup.component';
import { SalesRepAdvanceSearchPopupComponent } from './leads-popup/sales-rep-advance-search-popup/sales-rep-advance-search-popup.component';
import { BusinessPartnerAdvancedSearchPopupComponent } from './leads-popup/business-partner-advanced-search-popup/business-partner-advanced-search-popup.component';
import { DetailsPopupComponent } from './leads-popup/details-popup/details-popup.component';
import { BusinessPartnerModule } from '../business-partners/business-partner.module';
import { LeadsService } from './leads.service';
import { LeadsEmailPopupComponent } from './leads-popup/email-popup/email-popup.component';
import { LeadsEmailAddressInputComponent } from './leads-popup/email-popup/email-address-input/email-address-input.component';
import { AttachmentsComponent, HistoryComponent } from 'projects/shared/src/public-api';
import { LinksComponent } from 'projects/sales/src/app/shared/components/links/links.component'
Grid.Inject(InfiniteScroll);

@NgModule({
  declarations: [
    LeadsGridComponent,
    LeadsPopupComponent,
    SalesRepAdvanceSearchPopupComponent,
    BusinessPartnerAdvancedSearchPopupComponent,
    DetailsPopupComponent,
    LeadsEmailPopupComponent,
    LeadsEmailAddressInputComponent
  ],
  imports: [
    LeadsRoutingModule,
    BusinessPartnerModule,
    CommonModule,
    SharedModule,
    LinksComponent,
    AttachmentsComponent,
    HistoryComponent,
    BusinessPartnerModule
  ],
  exports: [
    LeadsGridComponent,
    LeadsPopupComponent
  ],
  providers: [LeadsService]
})
export class LeadsModule { }
